<template>
    <div class="login-verify-wrapper pt-5">
        <div class="login-verify login-verify__container">
            <div class="login-verify__logo">
                <img src="/svg/gp-logo.svg" alt="gp-logo">
            </div>
            <div class="login-verify__email">
                <v-text-field
                    :value="email"
                    label="E-mail"
                    disabled
                ></v-text-field>
            </div>
            <div class="login-verify__email" v-if="channel === 'sms'">
                <v-text-field
                    :value="maskedPhone"
                    label="Телефон"
                    disabled
                ></v-text-field>
            </div>
            <div class="login-verify__hint">
                <p>{{ hintText }}</p>
            </div>
            <div class="login-verify__pin">
                <p>Введите код из {{ channel === 'email' ? 'письма' : 'смс' }}</p>
                <div class="otp-wrapper">
                    <input
                        v-for="(digit, index) in code"
                        :key="index"
                        ref="inputs"
                        :value="code[index]"
                        class="otp-input"
                        type="text"
                        inputmode="numeric"
                        maxlength="1"
                        autocomplete="one-time-code"
                        @input="onInput(index, $event)"
                        @keydown="onKeyDown(index, $event)"
                        @paste="onPaste"
                    />
                </div>

                <div class="login-verify__pin__error" v-if="errorSubmitCode">
                    <p>Введен неверный код.</p>
                </div>

                <div class="login-verify__pin__button">
                    <button @click="submitCode" :disabled="formattedCode.length !==6">
                        <span v-if="!loading">Подтвердить</span>

                        <span v-else class="loader-wrapper">
                                <img src="/img/button-loader.gif" alt="loading" class="button-loader">
                            </span>
                    </button>
                </div>

                <div class="login-verify__pin__send-code">
                    <p v-if="timer > 0">Отправить код повторно можно через {{ formattedTime }}</p>
                    <p v-else @click="resendCode" class="resend-text">Отправить код повторно</p>
                </div>

                <div v-if="showSmsButton" class="login-verify__alt-login">
                    <button class="sms-button" @click="switchEnterChannel">
                        {{ channel === 'email' ? 'Войти через SMS' : 'Войти через email' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['email', 'phone', 'method'],
    data: () => ({
        code: ['', '', '', '', '', ''],
        timer: 60,
        timerInterval: null,
        loading: false,
        channel: 'email',
        resendCount: 0,
        showSmsButton: false,
        errorSubmitCode: false,
    }),
    created() {
        this.startTimer();

        // автофокус на первое поле
        this.$nextTick(() => {
            if (this.$refs.inputs && this.$refs.inputs[0]) {
                this.$refs.inputs[0].focus();
            }
        })
    },
    beforeDestroy() {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = null;
        }
    },
    computed: {
        formattedTime() {
            const minutes = Math.floor(this.timer / 60)
            const seconds = this.timer % 60

            return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
        },
        formattedCode() {
            return this.code.join('');
        },
        maskedPhone() {
            if (!this.phone) {
                return '';
            }

            const phone = String(this.phone);
            const visibleStartLength = Math.min(2, phone.length);
            const visibleEndLength = phone.length > 4 ? 2 : 0;
            const maskLength = Math.max(phone.length - visibleStartLength - visibleEndLength, 0);

            return phone.slice(0, visibleStartLength)
                + '*'.repeat(maskLength)
                + phone.slice(phone.length - visibleEndLength);
        },
        hintText() {
            return this.channel === 'email'
                ? 'На указанную почту отправили код подтверждения.'
                : 'На указанный в профиле номер телефона направлен код подтверждения смс'
        },
    },
    methods: {
        onInput(index, event) {
            const value = event.target.value.replace(/[^0-9]/g, '')

            // записываем только один символ
            this.code.splice(index, 1, value.charAt(0) || '')

            // переход вперёд
            if (value && index < this.code.length - 1) {
                this.$refs.inputs[index + 1].focus()
            }

            // если все заполнены — отправляем код
            if (this.code.every(v => v !== '')) {
                this.submitCode();
            }
        },

        onKeyDown(index, event) {
            if (event.key === 'Backspace') {
                event.preventDefault()


                if (this.code[index]) {
                    // очищаем текущую ячейку
                    this.code.splice(index, 1, '')
                    this.$refs.inputs[index].value = ''
                } else if (index > 0) {
                    // переходим назад и очищаем предыдущую
                    this.$refs.inputs[index - 1].focus()
                    this.code.splice(index - 1, 1, '')
                    this.$refs.inputs[index - 1].value = ''
                }
                return
            }

            // навигация стрелками
            if (event.key === 'ArrowLeft' && index > 0) {
                this.$refs.inputs[index - 1].focus()
            }

            if (event.key === 'ArrowRight' && index < this.code.length - 1) {
                this.$refs.inputs[index + 1].focus()
            }
        },

        onPaste(event) {
            event.preventDefault()

            const paste = event.clipboardData
                .getData('text')
                .replace(/\D/g, '')
                .slice(0, 6)

            if (!paste) return

            for (let i = 0; i < 6; i++) {
                this.code.splice(i, 1, paste[i] || '')
                this.$refs.inputs[i].value = paste[i] || ''
            }

            const last = Math.min(paste.length, 6) - 1
            if (last >= 0) this.$refs.inputs[last].focus()

            if (this.code.every(v => v !== '')) {
                this.submitCode();
            }
        },

        startTimer() {
            // защита от нескольких таймеров
            if (this.timerInterval) {
                clearInterval(this.timerInterval)
            }

            this.timer = 60

            this.timerInterval = setInterval(() => {
                if (this.timer > 0) {
                    this.timer--;
                } else {
                    clearInterval(this.timerInterval)
                    this.timerInterval = null
                }
            }, 1000)
        },

        resetCode() {
            this.code = ['', '', '', '', '', '']
            this.$nextTick(() => {
                if (this.$refs.inputs[0]) this.$refs.inputs[0].focus()
            })
        },

        switchEnterChannel() {
            if (this.channel === 'sms') {
                this.channel = 'email'
            } else {
                this.channel = 'sms';
            }

            this.resetCode()
            this.startTimer()

            // сразу отправляем код по SMS
            this.resendCode()
        },

        async resendCode() {
            if (this.loading) {
                return;
            }

            this.loading = true;

            try {
                let response;

                try {
                    response = await axios.post('/login/refresh', {
                        channel: this.channel,
                    });

                    const data = response.data;

                    if (data.used_channel) {
                        this.method = data.used_channel;
                    }
                } catch (error) {
                    if (this.channel !== 'sms' && this.phone) {
                        this.channel = 'sms';

                        response = await axios.post('/login/refresh', {
                            channel: 'sms',
                        });
                    } else {
                        throw error;
                    }
                }

                this.resendCount++;
                // после 2 повторных запросов предлагаем SMS
                if (this.resendCount >= 2 && this.phone) {
                    this.showSmsButton = true;
                }

                this.resetCode();
                this.startTimer();

                if (response.data.message) {
                    PNotify.success(response.data.message);
                }

            } catch (error) {
                console.log('Ошибка повторной отправки', error);

                const message =
                    error.response &&
                    error.response.data &&
                    error.response.data.message
                        ? error.response.data.message
                        : 'Не удалось отправить код повторно.';

                PNotify.error(message);
            } finally {
                this.loading = false;
                this.errorSubmitCode = false;
            }
        },

        updateCsrfToken(token) {
            const meta = document.head.querySelector('meta[name="csrf-token"]');
            if (meta) {
                meta.setAttribute('content', token);
            }

            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        },

        async submitCode() {
            if (this.formattedCode.length !== 6 || this.loading) {
                return
            }

            this.loading = true;

            try {
                const response = await axios.post('/login/verify', {
                    code: this.formattedCode,
                })

                if (response.data && response.data.csrf_token) {
                    this.updateCsrfToken(response.data.csrf_token);
                }

                if (response.data.success) {
                    window.location.href = '/dashboard';
                } else {
                    if (response.data.message) {
                        PNotify.error(response.data.message);
                    }

                    this.errorSubmitCode = true;
                }
            } catch (error) {
                console.error('Ошибка подтверждения', error)
            } finally {
                this.loading = false
            }
        }
    },
    watch: {
        method: {
            handler(val) {
                if (val === 'phone' || val === 'sms') {
                    this.channel = 'sms';
                } else {
                    this.channel = 'email';
                }
            },
            deep: true,
            immediate: true,
        },
    },
}
</script>

<style scoped lang="scss">
$max-mobile-width: 767px;

.otp-wrapper {
    display: flex;
    justify-content: center;
    gap: 8px;
}

.otp-input {
    width: 48px;
    height: 56px;
    font-size: 28px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 8px;
    outline: none;
    transition: border 0.2s, box-shadow 0.2s;
    background-color: #E8E8E8;
}

.otp-input:focus {
    border-color: #00BA57;
    box-shadow: 0 0 0 2px rgba(13, 218, 23, 0.2);
}

p {
    margin-bottom: 0;
}

.login-verify-wrapper {

}

.login-verify {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px 40px;
    border-radius: 20px;
    -webkit-box-shadow: 0px 0px 10px 4px rgba(13, 149, 77, 0.2);
    -moz-box-shadow: 0px 0px 10px 4px rgba(13, 149, 77, 0.2);
    box-shadow: 0px 0px 10px 4px rgba(13, 149, 77, 0.2);
    background-color: #FFFFFF;

    @media(max-width: $max-mobile-width) {
        padding: 10px 20px;
    }


    &__container {
        max-width: 600px;
        width: 100%;
    }

    &__logo {
        margin-bottom: 20px;
        @media(max-width: $max-mobile-width) {
            padding: 10px 20px;
        }

        img {
            max-width: 140px;
        }
    }

    &__hint {
        border: 1px solid #c3c3c3;
        padding: 8px 14px;
        border-radius: 8px;
        font-size: 12px;
    }

    &__email {
        width: 100%;
    }

    &__pin {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        margin-top: 40px;

        &__error {
            p {
                font-family: 'SFPro', 'Arial', 'sans-serif';
                font-size: 12px;
                color: #FF5252;
            }
        }

        &__button {
            button {
                padding: 14px 20px;
                background-color: #00BA57;
                color: #FFF;
                font-size: 16px;
                width: 240px;
                border-radius: 30px;

                &:disabled {
                    cursor: not-allowed;
                    /*color: #A6A6A6;
                    background-color: #E0E0E0;*/
                }
            }

            .loader-wrapper {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .button-loader {
                width: 24px;
                height: 24px;
            }
        }

        &__send-code {
            p {
                font-family: 'SFPro', 'Arial', 'sans-serif';
                font-size: 12px;
            }

            .resend-text {
                color: #00BA57;
                cursor: pointer;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/LoginVerify.vue